import { defineComponent as d, openBlock as u, createBlock as f, unref as s, withCtx as o, createVNode as n, normalizeStyle as i, normalizeClass as m, renderSlot as a } from "vue";
import "./ghl-ui.es181.js";
import h from "./ghl-ui.es182.js";
import c from "./ghl-ui.es183.js";
const w = d({
  name: "UIModal",
  inheritAttrs: !1
}), y = d({
  ...w,
  props: {
    show: {
      type: Boolean,
      default: !1
    },
    width: {
      type: Number,
      default: 544
    },
    zIndex: {
      type: Number,
      default: void 0
    },
    to: {
      type: String,
      default: "body"
    },
    autoFocus: {
      type: Boolean,
      default: !1
    },
    className: {
      type: String,
      default: ""
    },
    maskClosable: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:show"],
  setup(e) {
    return (t, l) => (u(), f(s(h), {
      show: e.show,
      "onUpdate:show": l[0] || (l[0] = (r) => t.$emit("update:show", r)),
      "z-index": e.zIndex,
      "auto-focus": e.autoFocus,
      to: e.to,
      "mask-closable": e.maskClosable
    }, {
      default: o(() => [
        n(s(c), {
          style: i({ width: `${e.width}px` }),
          bordered: !1,
          size: "huge",
          role: "dialog",
          "aria-modal": "true",
          class: m(["hl-modal", e.className])
        }, {
          header: o(() => [
            a(t.$slots, "header")
          ]),
          footer: o(() => [
            a(t.$slots, "footer")
          ]),
          default: o(() => [
            a(t.$slots, "default")
          ]),
          _: 3
        }, 8, ["style", "class"])
      ]),
      _: 3
    }, 8, ["show", "z-index", "auto-focus", "to", "mask-closable"]));
  }
}), k = y;
export {
  k as default
};
